export interface ICurrency {
  id: number
  code: string
  symbol: string
}
export const CURRENCIES:Record<string, ICurrency> = {
  USD: {id: 1, code: 'USD', symbol: '$'},
  GBP: {id: 3, code: 'GBP', symbol: '£'},
}